import FieldsetProductGeneral from './FieldsetProductGeneral.yaml?component';
import UcProductGeneral from './UcProductGeneral.yaml?component';
import UcProductPrices from './UcProductPrices.yaml?component';

export { FieldsetProductGeneral, UcProductGeneral, UcProductPrices };
